import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import MoneySigned from "./MoneySigned";
import TransactionPageIcon from "app/components/TransactionPageIcon";
import { clientConfigFn } from "clientConfig";
const getColour = (direction) => {
    const config = clientConfigFn();
    switch (direction) {
        case "credit":
            return config.showTransactionsAsLender ? "red" : "green";
        case "debit":
            return config.showTransactionsAsLender ? "green" : "red";
    }
};
const TransactionPageIconMoney = ({ amount = 0, direction, isShowZero, }) => {
    const colour = getColour(direction);
    if (amount === 0 && !isShowZero) {
        return null;
    }
    return (_jsxs("span", { className: "transactionpage-moneyicon", children: [_jsx(TransactionPageIcon, { iconName: direction, style: { color: colour } }), _jsx(MoneySigned, { amount: amount, direction: direction, isShowZero: isShowZero })] }));
};
export default TransactionPageIconMoney;
